import { BottomActionBar } from '@bridebook/ui';
import { ReactNode } from 'react';
import styles from './submit-button-mobile-wrapper.style';

interface IProps {
  children: ReactNode;
}

const SubmitButtonMobileWrapper = ({ children }: IProps) => (
  <BottomActionBar variant="sticky-bottom" style={styles.wrapper}>
    {children}
  </BottomActionBar>
);

export default SubmitButtonMobileWrapper;
